import { h } from "preact";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Popconfirm } from "antd";
import { Text } from "../../../components/text";
import { Center } from "../../../style/styled";
import { TagCompoent } from "../../../components/tag/styled";
import { getPropertiesStatus } from "../../../functions";
import { IColumnData } from "../interfaces/table";
import { color } from "../../../resources";

export const COULMN_DATA = (props?: any): IColumnData[] => [
  {
    title: "ลำดับ",
    dataIndex: "index",
    key: "index",
    width: "4em",
  },
  {
    title: "รหัสคำขอ",
    dataIndex: "requestNo",
    key: "requestNo",
    width: "8em",
  },
  {
    title: "หมายเลขการซ่อม",
    dataIndex: "maintainId",
    key: "maintainId",
    width: "10em",
    render: (text) => {
      return <Text size={"S"} text={text as string} bold={true} />;
    },
  },
  {
    title: "หมายเลขเครื่องตัด",
    dataIndex: "deviceId",
    key: "deviceId",
    width: "10em",
  },
  {
    title: "version เครื่องตัด",
    dataIndex: "versionMachine",
    key: "versionMachine",
    width: "10em",
  },
  {
    title: "รหัสเซลล์",
    dataIndex: "saleCode",
    key: "saleCode",
    width: "6em",
  },
  {
    title: "รหัสลูกค้า",
    dataIndex: "customerCode",
    key: "customerCode",
    width: "10em",
  },
  {
    title: "ชื่อลูกค้า",
    dataIndex: "customerName",
    key: "customerName",
    width: "12em",
  },
  {
    title: "หมายเลขเครื่องสแปร์",
    dataIndex: "deviceSpareId",
    key: "deviceSpareId",
    width: "10em",
    render: (text) => {
      return <Text size={"S"} text={text as string} bold={true} />;
    },
  },
  {
    title: "เหตุผลขอสแปร์",
    dataIndex: "reasonSpare",
    key: "reasonSpare",
    width: "16em",
  },
  {
    title: "ซ่อม / เคลม",
    dataIndex: "maintainTypeDisplay",
    key: "maintainTypeDisplay",
    width: "8em",
    fixed: "right",
    render: (text) => {
      return (
        <Text
          size={"S"}
          text={`${text}`}
          bold={true}
          color={
            `${text}` === "เปลี่ยน"
              ? color.btn_primary
              : color.btn_hover_primary
          }
        />
      );
    },
  },
  {
    title: "สถานะ",
    dataIndex: "maintainSpareStatus",
    key: "maintainSpareStatus",
    fixed: "right",
    width: "10em",
    render: (text) => {
      const { color, text: t } = getPropertiesStatus(`${text}`);
      return (
        <Center>
          <TagCompoent color={color}>{t}</TagCompoent>
        </Center>
      );
    },
  },
  {
    title: "",
    key: "button",
    width: "10em",
    fixed: "right",
    render: (_record: any) => {
      return (
        <div>
          <Popconfirm
            placement="bottomRight"
            title={"คุณต้องการลบรายการ"}
            onConfirm={() => props.onDelete(_record)}
            okText="ใช่"
            cancelText="ไม่ใช่"
            disabled={_record.maintainSpareStatus === "STSH-100"}
          >
            {
              (
                <Button
                  type="primary"
                  shape="circle"
                  icon={(<DeleteOutlined />) as React.ReactNode}
                  style={{ marginRight: 10 }}
                  danger
                  disabled={_record.maintainSpareStatus === "STSH-100"}
                />
              ) as React.ReactNode
            }
          </Popconfirm>
          <Button
            type="primary"
            shape="circle"
            onClick={() => props.onEdit(_record)}
            disabled={_record.maintainSpareStatus === "STSH-100"}
            icon={(<EditOutlined />) as React.ReactNode}
          />
        </div>
      );
    },
  },
];
